/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Exclusive_ListingInputs */

const cs_form_exclusive_listing = /** @type {(inputs: Form_Exclusive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výhradní zakázka`)
};

const en_form_exclusive_listing = /** @type {(inputs: Form_Exclusive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive listing`)
};

/**
* | output |
* | --- |
* | "Exclusive listing" |
*
* @param {Form_Exclusive_ListingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_exclusive_listing = /** @type {((inputs?: Form_Exclusive_ListingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Exclusive_ListingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_exclusive_listing(inputs)
	return cs_form_exclusive_listing(inputs)
});